import { Quote } from "lucide-react";
import { PROPRIETOR } from "@/data/site";

export default function Leadership() {
  return (
    <section
      id="leadership"
      data-testid="leadership-section"
      className="section-pad relative bg-[#0A1128]/40 border-y border-white/5"
    >
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="text-xs uppercase tracking-[0.3em] text-[#FFC857] mb-6">
              — Leadership
            </div>
            <Quote className="h-10 w-10 text-[#FFC857]/60 mb-4" />
            <h2 className="font-serif text-4xl md:text-5xl text-white font-light leading-[1.15]">
              {PROPRIETOR.name}
            </h2>
            <div className="mt-2 text-sm uppercase tracking-[0.25em] text-[#FFC857]">
              {PROPRIETOR.role}
            </div>

            <div className="mt-8 space-y-5 text-[#A0ABC0] font-light text-base md:text-lg leading-relaxed">
              {PROPRIETOR.bio.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6 border-t border-white/10 pt-8">
              <div>
                <div className="font-serif text-3xl text-[#FFC857]">10+</div>
                <div className="text-xs uppercase tracking-widest text-[#A0ABC0] mt-2">
                  Years at TIME & RYTHM
                </div>
              </div>
              <div>
                <div className="font-serif text-3xl text-[#FFC857]">2014</div>
                <div className="text-xs uppercase tracking-widest text-[#A0ABC0] mt-2">
                  Evergreen Edulife
                </div>
              </div>
              <div>
                <div className="font-serif text-3xl text-[#FFC857]">30</div>
                <div className="text-xs uppercase tracking-widest text-[#A0ABC0] mt-2">
                  Team at Jashvi
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 order-1 lg:order-2">
            <div className="relative">
              <div className="absolute -inset-3 sun-ring opacity-50" />
              <img
                data-testid="proprietor-portrait"
                src={PROPRIETOR.portrait}
                alt={PROPRIETOR.name}
                className="relative w-full aspect-[5/6] object-cover rounded-sm border border-white/10"
              />
              <div className="absolute bottom-6 left-6 right-6 glass px-6 py-4 rounded-sm">
                <div className="text-xs uppercase tracking-[0.25em] text-[#FFC857]">
                  Founder's note
                </div>
                <p className="font-serif text-lg text-white mt-2 italic">
                  "Solar is a 30-year promise. We build for the long arc."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
